/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_TeamsInputs */

const en_cp_form_teams = /** @type {(inputs: Cp_Form_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated number of teams`)
};

const id_cp_form_teams = /** @type {(inputs: Cp_Form_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perkiraan jumlah tim`)
};

/**
* | output |
* | --- |
* | "Estimated number of teams" |
*
* @param {Cp_Form_TeamsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_teams = /** @type {((inputs?: Cp_Form_TeamsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_TeamsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_teams(inputs)
	return en_cp_form_teams(inputs)
});